module.exports = __webpack_public_path__ + "610e092c11a966831e5bbc57d0ed369e.svg";